import { IContactDto } from "../contact/Contact.model"
import { IFilterDto, IPagination, TFieldDefinition } from "../../common/model/Core.model"

export interface IClientCreateRequestDto {
  displayName: string
  countryCode: string
  country: string
  contacts: IContactDto[]
  sectorCode?: string
  sector?: string
  address?: string
  latitude?: string
  longitude?: string
}

export interface IClientListRequestDto {
  limit?: number
  sort?: 'ASC' | 'DES'
  page?: string
}

export interface IClientUpdateRequestDto {
  id: string
  displayName: string
  sectorCode?: string
  sector?: string
  countryCode: string
  country?: string
  address?: string
  latitude?: string
  longitude?: string
  contacts: IContactDto[]
}

export interface IClientDto {
  id: string
  sequence: string
  createdAt: string
  updatedAt: string
  organizationId: string
  sectorCode: string
  sector: string
  displayName: string
  contacts: IContactDto[]
  address: string
  countryCode: string
  country: string
  latitude: string
  longitude: string
  totalContract: number
  totalAsset: number
  totalReport: number
}

export interface IClientListItemDto {
  id: string
  sequence: string
  createdAt: string
  updatedAt: string
  sector: string
  displayName: string
  address: string
  country: string
}

export interface IClientSearchRequestDto {
  pagination?: IPagination
  fields?: TFieldDefinition
  filters?: IFilterDto[]
}

export enum IClientFilter {
  HASH = 'HASH',
  ID = 'ID',
  NAME = 'NAME',
  SECTOR = 'SECTOR',
  COUNTRY = 'COUNTRY',
  ADDRESS = 'ADDRESS',
}

export interface IClientRequestOptions {
  details?: boolean
  fields?: TFieldDefinition
}

export interface IClientLogDto {
  createdBy: string
  createdAt: string
  organizationId: string
  clientId: string
  id: string
  action: string
  description: string
}

export interface IClientNestedDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  id: string
  sequence: string
  status: string
  sectorCode: string
  sector: string
  displayName: string
  countryCode: string
  country: string
  address: string
  latitude: string
  longitude: string
}